import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Button } from '@hivebrite/design-system/Button';

import { blockUser } from 'hb-react/frontoffice/utils/blockUser';
import { useEventsIndexContext } from 'hb-react/shared/apps/Events/contexts/EventsIndexContext';

const Blocked = ({ user }) => {
  const { setHiddenUsersIds } = useEventsIndexContext();

  const handleShowUser = () => {
    blockUser(user.id);

    setHiddenUsersIds((prev) => prev.filter((id) => id !== user.id));
  };

  return (
    <StyledCard>
      <Box font="h4-semibold" mb={3}>
        {I18n.t('web.hide_user_publications.success_message', {
          username: user?.name,
        })}
      </Box>
      <Button onClick={handleShowUser}>{__('Cancel')}</Button>
    </StyledCard>
  );
};

export default Blocked;

const StyledCard = styled(Card).withConfig({
  shouldForwardProp: (prop) => !['hoverStyle', 'selected'].includes(prop),
})`
  height: 100%;
`;
